<script>
import { sidebarComputed, sidebarMethods } from '@state/helpers';

export default {
  components: {},
  props: {
    collapsible: {
      type: Boolean,
      required: false,
    },
    type: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      collapsed: true,
    };
  },
  computed: {
    ...sidebarComputed,
  },
  mounted() {},
  methods: {
    ...sidebarMethods,
    collapse() {
      this.setIsSidebarCollapsed();
    },
  },
};
</script>

<template>
  <div
    :class="[
      'sidebar',
      { collapsible: collapsible, collapsed: isSidebarCollapsed },
      type,
    ]"
  >
    <div class="collapse-wrapper" v-if="collapsible" @click="collapse">
      <img
        class="icon-collapse"
        src="@assets/images/icon-arrows-collapse.svg"
        v-if="!isSidebarCollapsed"
      />
      <img
        class="icon-collapse"
        src="@assets/images/icon-arrows-expand.svg"
        v-else
      />
    </div>
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.sidebar {
  background-color: $color-sidebar-bg;
  height: 100%;
  overflow-y: scroll;
  padding: 4rem 2rem 12rem;
  transition: width $duration-animation-base - 0.25 linear;
  width: 22rem;

  &.light {
    background-color: white;
  }

  .sidebar-section-title {
    font-size: 1.3rem;
    font-weight: 900;
    letter-spacing: 0.108333px;
    line-height: 2.2rem;
    margin-bottom: 3rem;
    position: relative;
    text-transform: uppercase;

    &::before {
      background-color: $color-gray;
      content: '';
      height: 0.1rem;
      position: absolute;
      top: 3rem;
      width: 3rem;
    }
  }

  .sidebar-section-container {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: center;

    a {
      color: $color-gray;
      font-size: 1.1rem;
      margin-left: 2.4rem;
    }

    .siderbar-section-title {
      color: $color-heading-text;
      font-family: $base-font-family;
      font-size: 1.2rem;
      font-weight: 900;
      letter-spacing: 0.1px;
      line-height: 2.2rem;
      margin-bottom: 1rem;
      text-transform: uppercase;
    }

    .sidebar-subtitle {
      color: $color-heading-text;
      font-family: $base-font-family;
      font-size: 12px;
      font-style: normal;
      font-weight: 900;
      letter-spacing: 0.1px;
      line-height: 22px;
      margin-bottom: 1rem;
      text-transform: uppercase;
    }
  }

  .sidebar-section {
    margin-bottom: 3.2rem;
  }

  // stylelint-disable selector-pseudo-element-no-unknown
  ::v-deep input[type='text'] {
    background-color: white;
  }

  &.collapsible {
    padding-top: 0;

    .collapse-wrapper {
      align-items: center;
      display: flex;
      justify-content: center;
      padding: 1.5rem 2rem 1.5rem;

      .icon-collapse {
        border-bottom: 1px solid $color-gray;
        padding-bottom: 1.75rem;

        &:hover {
          cursor: pointer;
        }
      }
    }

    &.collapsed {
      width: 7.2rem;
    }
  }
}
</style>
